$(document).on('click', '[data-add]', (e) => {
  e.preventDefault();
  const items = $($(e.target).data('add'));
  const template = $(items[items.length - 1]);
  template.parent().append(template.clone().html(template.html().replaceAll(`[${items.length - 1}]`, `[${items.length}]`)));
});
